import { PauseCircleOutline } from "@mui/icons-material";
import { Chip, Tooltip } from "@mui/material";
import { normalizeDocName } from "@repo/types";
import { formatDate } from "@repo/utils/date";
import { useTranslation } from "react-i18next";
import { toDateLocale } from "@/utils/date-locale";

type Props = {
  pausedAt?: string | Date | null;
  expiredDocuments?: readonly string[] | null;
  size?: "small" | "medium";
};

/** Soft pause set by the document expiry escalation (not the Cognito disable). */
export function DriverExpiryPauseBadge({ pausedAt, expiredDocuments, size = "small" }: Props) {
  const { t, i18n } = useTranslation();
  if (!pausedAt) return null;

  const documents = (expiredDocuments ?? [])
    .map((name) => t(`notifications.documents.${normalizeDocName(name)}`, { defaultValue: name }))
    .join(", ");
  const details = [
    t("driver.expiryPause.since", {
      date: formatDate(pausedAt, { locale: toDateLocale(i18n.language) }),
    }),
    documents ? t("driver.expiryPause.documents", { documents }) : "",
  ]
    .filter(Boolean)
    .join(" · ");

  return (
    <Tooltip title={details}>
      <Chip
        data-testid="driver-expiry-pause-badge"
        icon={<PauseCircleOutline />}
        label={
          size === "medium"
            ? `${t("driver.expiryPause.badge")} · ${details}`
            : t("driver.expiryPause.badge")
        }
        color="warning"
        size={size}
        variant="outlined"
      />
    </Tooltip>
  );
}
